import { LocalePrefix, PrefixToCurrencyMap, PrefixToLocaleMap } from '@tmh-website/shared/const';

/**
 * Formats a given price for the end user.
 *
 * @param cents
 * @param locale
 * @returns The formatted price
 */
export function formatCurrency({ amount, locale }: { amount: number; locale: LocalePrefix }) {
  return Intl.NumberFormat(PrefixToLocaleMap[locale], {
    style: 'currency',
    currency: PrefixToCurrencyMap[locale],
  }).format(amount);
}
